export const customPdfAppearanceTemplateQueryKeys = {
  all: ["custom-pdf-appearance-templates"] as const,
};
